<template>
	<div>
        <div v-if="original_preview" id="preview" class="text-center">
            <span class="btn btn-sm bg-gray-300 btn-ghost-light" ><i class="fas fa-times" @click="removeFile()"></i></span>
            <img :src="default_url" class="img-fluid">
        </div>

		<div v-else id="preview" class="text-center">
            <!-- Only show if a new file has been uploaded -->
            <template v-if="file">
                <span class="btn btn-sm bg-gray-300 btn-ghost-light" ><i class="fas fa-times" @click="removeFile()"></i></span>
                
                <!-- Image File -->
    			<img v-if="file.type.startsWith('image/')" :src="url" class="img-fluid">

                <!-- PDF -->
                <iframe v-else-if="file.type == 'application/pdf'" id="viewer" :src="url" frameborder="none"></iframe>

                <!-- Everything else -->
                <div v-else>
                    <div class="text-center text-white py-4 rounded" style="width:100%; background-color:#a3a8ac">
                        <div class="rounded-circle mx-auto mb-2" style="background-color:#f7f7f7; width:50px; height:50px;"><i class="far fa-image" style="color:#a3a8ac; font-size:1.8rem; line-height:50px"></i></div>
                        <div style="line-height:1rem"><strong>Preview<br>not available</strong></div>
                    </div>
                    {{ file.name }}
                </div>
            </template>
		</div>

		<div class="filezone"> 
			<input type="file" id="files" ref="files" @change="onFileChange" />
			<p>Drop file here <br>or click to browse</p>
		</div>

	</div>
</template>

<script>
	export default {
        props: ['default_url'],
		
		data () {
			return {
                original_preview: this.default_url,

				url: this.default_url,
                file: null,
			}
		},

		methods: {
		    onFileChange(e) {
                this.original_preview = null;
                
                this.file = e.target.files[0];
                this.url = URL.createObjectURL(this.file);
                
                //send it back up
                this.$emit('file_changed', this.url );                
		    },

		    removeFile() {
                this.original_preview = null;
                this.file = null;
                this.$refs.files.value = '';
		    }
		}
	}	

</script>

<style scoped>
    input[type="file"]{
        opacity: 0;
        width: 100%;
        height: 100%;
        position: absolute;
        left:0;
        cursor: pointer;
    }
    .filezone {
        outline: 1px dotted #cacccd;
        outline-offset: -8px;
        background: #f0f3f5;
        color: #23282c;
        position: relative;
        cursor: pointer;
        margin-top:20px; 
        transition:.2s all ease-out;
    }
    .filezone:hover {
        background: #2f353a;
        color:#fff;
        transition:.15s all ease-in-out;
    }

    .filezone p {
        font-size: .875rem;
        text-align: center;
        padding: 10px;
        margin-bottom: 0px;
    }

#preview { 
    position:relative;
/*    max-width: 200px;
    max-height: 300px;*/
}

#preview img {
    /*max-width: 200px;*/
    max-height: 400px;
}

#preview span.btn { position:absolute; top:-5px; right:-5px; }  

iframe {
    width:100%;
}

</style>